import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Card, CardBody, CardTitle, Modal, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "reactstrap";
import OverviewChart from "./overviewChart";
import { options, series } from "common/data/labs";
import AttachedFiles from "./attachedFiles";
import Comments from "./comments";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import LabDetail from "./LabDetails";
import Reviews from "./Reviews";


import {getLabDetail,getReviewsListRequest, getEqaListRequest} from "store/viewlabs/actions";

class LabOverview extends Component {
  constructor(props) {
    super(props);
    this.state = { 
     lab:"",
     reviews:"",
     eqas:[],

};
  }
  componentDidMount() {
    //params is an object with key value pairs of the url params
    const {
      match: { params }, //match : {params } so that we can access the params object containing the id passed in the url
    
      getLabDetail,
      getReviewsListRequest,
      getEqaListRequest //we are destructuring the props object and accessing the getServiceDetail function
    } = this.props;
    console.log(params.email);
    // if (params && params.id) {
      
    
      getLabDetail(params.email); 

      const {labDetail} = this.props;
 console.log("lab detail in overview",labDetail);
 getReviewsListRequest(params.email)
 this.setState({reviews:this.props.reviews})
 console.log("reviews", this.props.reviews)

 getEqaListRequest(params.email)
      this.setState({eqas:this.props.eqas})
      console.log("EQA", this.props.eqas)
    // else {
    //     console.log("no id")
    
    //   // remove this page from history so that the user is redirected to the home page
    //   // this.props.history.replace("/");
    // }
  }

  render() {
 const {labDetail}= this.props
 const {reviews}=this.props
 const {eqas}=this.props
 console.log(reviews)
 
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem={labDetail.name} />
            {this.props.loading && (
              <div className="text-center " style={{
                
              }}>
                <i className="bx bx-loader bx-spin align-middle me-2" style={{fontSize:48,color:'#2A3042'}}/>
              </div>
            )}
            {!isEmpty(labDetail) && !this.props.loading && (
              <>
                
                  <Col lg="12" className="mt-0" >
                   
                    <LabDetail lab={labDetail} />

                    <Row>
                  {/* <Col lg="4">
                    <AttachedFiles files={projectDetail.files} />
                  </Col>
                  <Col lg="4">
                    <Comments comments={projectDetail.comments} />
                  </Col> */}
                  <Col className="mb-3">
                  <Card>
                    <CardBody>
                   <CardTitle className="mb-4">
                    E-QA </CardTitle>
                    <hr
        style={{
          background: 'black',
          color: 'black',
          borderColor: 'black',
          height: '2px',
        }}
      />
      
                   <Table className="table table-nowrap align-middle table-hover mb-0 ">
                   <tbody>
                   {this.props.eqas.map ((item, index) => {
                    return(
                    <tr key={index}>
                    <td style={{ width: "45px" }}>
                    {index}
                   </td>
                   <td>
                     <h5 className="font-size-14 mb-1">
                       <Link to="#" className="text-dark">
                        EQA Certificate
                       </Link>
                     </h5>
                   </td>
                   <td>
                     <div className="text-center">
                     <a
                         
                         href={item.Certificate}
                             className="text-dark"
                             download
                           >
                             <i className="bx bx-download h3 m-0" />
                           </a>
                     </div>
                   </td>
                 </tr>
                    )
                    
                   })}
              </tbody>
            </Table>
       
        </CardBody>
        </Card>
                  
        </Col>
        <Col className="mb-3">
        <Card className="h-100">

          <CardBody>
            <CardTitle className="mb-4"> Reviews</CardTitle>
            <hr
        style={{
          background: 'black',
          color: 'black',
          borderColor: 'black',
          height: '2px',
        }}
      />
      <Reviews
                      // comments={projectDetail.comments}
                      reviews={this.props.reviews}
                      Lab={labDetail}
                      // ServiceID={serviceDetail.id}
                      title="Reviews"
                    />
          </CardBody>
        </Card>
        
        
        </Col>

                  
          </Row>
                  </Col>

                  
             

            
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LabOverview.propTypes = {
loading: PropTypes.bool,
  match: PropTypes.object,
  lab: PropTypes.object,
  testDetail: PropTypes.any,
  labDetail: PropTypes.any,
  getTestDetail: PropTypes.func,
  getLabDetail: PropTypes.func,
  getReviewsListRequest:PropTypes.func,
  reviews:PropTypes.any,
  getEqaListRequest:PropTypes.func,
  eqas:PropTypes.any,
};

const mapStateToProps = state => ({
  labDetail: state.LabReducer.lab,
  loading: state.LabReducer.isLoading,
  reviews:state.LabReducer.reviews,
  eqas:state.LabReducer.eqas,

 
});

const mapDispatchToProps = dispatch => ({
 
 
getLabDetail: email => dispatch(getLabDetail(email)),
getReviewsListRequest: email => dispatch(getReviewsListRequest(email)),
getEqaListRequest: email => dispatch(getEqaListRequest(email)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LabOverview));